/* eslint-disable jsx-a11y/anchor-is-valid */
import i18next from 'i18next';
import { string } from 'prop-types';
import React from 'react';
import { arrayOf } from 'prop-types';
import { shape } from 'prop-types';

import { FORMAT_TIME, FORMAT_DATE } from '~utils/time';

import DeliveryTypeInfo from '../../../DeliveryTypeInfo';
import { CHANNEL_ICONS, MERCAT_CHANNEL } from '../../../ChannelInfo/constants';
import styles from '../../styles.module.scss';

const Delivery = ({ channel, deliveries, dispatchMethod, deliveryTime, createdAt, storeName, posId }) => {
  const deliveryTrackLink = deliveries[0]?.trakingUrl;
  const deliveryConfirmationCode = deliveries[0]?.confirmationCode;
  const deliveryReferenceCode = deliveries[0]?.referenceCode;

  return (
    <div className={`m-left-2 ${styles.border}`}>
      {CHANNEL_ICONS[channel] ? (
        <div className="row middle">
          <div className={styles.clientTitle}>
            <span className="bold font-size-14">{i18next.t('OrdersDetails:channel')}</span>
          </div>
          <span className="font-size-14 m-right-6">
            {channel !== MERCAT_CHANNEL ? i18next.t(`DeliveryStatus:app`) : null}{' '}
            {i18next.t(`DeliveryStatus:${CHANNEL_ICONS[channel].appName}`)}
          </span>
        </div>
      ) : null}
      {posId ? (
        <div className="row middle">
          <div className={styles.clientTitle}>
            <span className="bold font-size-14">{i18next.t('OrdersDetails:posId')}</span>
          </div>
          <span className="font-size-14 m-right-6">{posId}</span>
        </div>
      ) : null}
      <div className="row middle">
        <div className={styles.clientTitle}>
          <span className="bold font-size-14">{i18next.t('OrdersDetails:store')}</span>
        </div>
        <span className="font-size-14 m-right-6">{storeName}</span>
      </div>
      <div className="row middle">
        <div className={styles.clientTitle}>
          <span className="bold font-size-14">{i18next.t('OrdersDetails:deliveryOption')}</span>
        </div>
        <span className="font-size-14 m-right-6">
          <DeliveryTypeInfo
            channel={channel}
            deliveries={deliveries}
            dispatchMethod={dispatchMethod}
            showDeliveryStatus={false}
            showDeliveryTypeAsText
          />
        </span>
        {deliveryTrackLink && (
          <a
            target="_blank"
            className={styles.link}
            href={deliveries[0]?.trakingUrl}
            rel="noopener noreferrer">
            {i18next.t('OrdersDetails:trackDelivery')}
          </a>
        )}
      </div>
      {deliveryConfirmationCode && (
        <div className="row middle">
          <div className={styles.clientTitle}>
            <span className="bold font-size-14">{i18next.t('OrdersDetails:deliveryConfirmationCode')}</span>
          </div>
          <span className="font-size-14 m-right-6">{deliveryConfirmationCode}</span>
        </div>
      )}
      {deliveryReferenceCode && (
        <div className="row middle">
          <div className={styles.clientTitle}>
            <span className="bold font-size-14">{i18next.t('OrdersDetails:deliveryReferenceCode')}</span>
          </div>
          <span className="font-size-14 m-right-6">{deliveryReferenceCode}</span>
        </div>
      )}
      <div className="row middle">
        <div className={styles.clientTitle}>
          <span className="bold font-size-14">{i18next.t('OrdersDetails:createdAt')}</span>
        </div>
        <span className="font-size-14 m-right-6">{createdAt.format(`${FORMAT_DATE} ${FORMAT_TIME}`)}</span>
      </div>
      <div className="row middle">
        <div className={styles.clientTitle}>
          <span className="bold font-size-14">{i18next.t('OrdersDetails:laterStartTime')}</span>
        </div>
        <span className="font-size-14 m-right-6">{deliveryTime.format(`${FORMAT_DATE} ${FORMAT_TIME}`)}</span>
      </div>
    </div>
  );
};

Delivery.propTypes = {
  channel: string,
  createdAt: shape({}),
  deliveries: arrayOf(shape({})),
  deliveryTime: shape({}),
  dispatchMethod: string,
  posId: string,
  storeName: string
};

export default Delivery;
